import { type TextFragment } from '@/utils/text-kit';
import { type ILayerProps, type ITextLayerProps } from '@/version-types';
import { CharTypedListMarkerRenderer } from './char-typed';
import { ImageTypedListMarkerRenderer } from './image-typed';
import { SVGTypedListMarkerRenderer } from './svg-typed';

type Props = {
    layer: ILayerProps;
    listMarkerFragments: TextFragment[];
};

export const ListMarkerRenderer: React.FC<Props> = ({ layer, listMarkerFragments }) => {
    const layerData = layer.data as ITextLayerProps;
    const { listStyle, listStyleMaterial } = layerData;

    if (listStyle === '' || listMarkerFragments.length === 0) return null;

    if (listStyleMaterial) {
        const type = listStyleMaterial.url.endsWith('.svg') ? 'svg' : 'image';

        if (type === 'image') {
            return <ImageTypedListMarkerRenderer layer={layer} listMarkerFragments={listMarkerFragments} />;
        }

        return <SVGTypedListMarkerRenderer layer={layer} listMarkerFragments={listMarkerFragments} />;
    }

    return <CharTypedListMarkerRenderer layer={layer} listMarkerFragments={listMarkerFragments} />;
};
